import { SUBSCRIPTION_EXPIRY_NOTICE_STORAGE_PREFIX } from '../constants/subscription-expiry-notice';
import { SubscriptionExpiryNoticeRecord } from './subscription-expiry-notice';

const buildKey = (tournamentId: number) => `${SUBSCRIPTION_EXPIRY_NOTICE_STORAGE_PREFIX}:${tournamentId}`;

export function readSubscriptionExpiryNotice(tournamentId: number): SubscriptionExpiryNoticeRecord | null {
  try {
    const raw = localStorage.getItem(buildKey(tournamentId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Мусор в ключе (ручная правка, старый формат) не должен ломать показ — считаем «не показывали».
    if (typeof parsed?.activeTo !== 'string' || typeof parsed?.shownAt !== 'number') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeSubscriptionExpiryNotice(tournamentId: number, record: SubscriptionExpiryNoticeRecord): void {
  try {
    localStorage.setItem(buildKey(tournamentId), JSON.stringify(record));
  } catch {
    // Приватный режим / переполненное хранилище: тост показать важнее, чем запомнить показ.
  }
}
